module.exports = __webpack_public_path__ + "static/media/first-american-logo.de939953.png";